module.exports = __webpack_public_path__ + "img/profile.e47c998a.jpeg";